import { Deserializable } from "@app/interfaces/deserializable";

export class ValidationRequest implements Deserializable {

    keyP: string;
    co: string;
    account: string;
    timestamp: Date;
    processedDate: Date;
    description: string;

    deserialize(input: any) {
        Object.assign(this, input);
        return this;
    }

}
